import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { guarantee } from '../data/content';
export function Guarantee() {
  return <section className="bg-ivory text-ink" data-id="element-81" data-mp="1o33u6h0ytshr">
      <div className="mx-auto max-w-content px-5 py-10 sm:px-6 lg:py-14" data-id="element-82" data-mp="223epbw9b5t8q">
        <div className="mx-auto flex max-w-2xl flex-col items-center gap-4 rounded-3xl border border-stone bg-ivory-card px-6 py-8 text-center sm:flex-row sm:items-start sm:gap-6 sm:px-8 sm:text-left" data-id="element-83" data-mp="221bwz5kono0u">
          <span className="flex h-14 w-14 flex-none items-center justify-center rounded-full bg-sage/20" data-id="element-84" data-mp="19co4oq1inyds">
            <ShieldCheckIcon className="h-7 w-7 text-sage-deep" aria-hidden="true" data-id="element-85" data-mp="14dtfn6cyhdl8" />
          </span>
          <div data-id="element-86" data-mp="1j6dcxqdfcqur">
            <h2 className="font-display text-2xl font-semibold uppercase leading-tight tracking-tight sm:text-3xl" data-id="element-87" data-mp="1ee3suqyzql0e">
              {guarantee.title}
            </h2>
            <p className="mt-2 font-sans text-base font-semibold text-ink" data-id="element-88" data-mp="qm6il4b6w11e">{guarantee.lead}</p>
            <p className="mt-1.5 font-sans text-[0.95rem] leading-relaxed text-ink/75" data-id="element-89" data-mp="lowmx6x7it54">{guarantee.body}</p>
            <p className="mt-4 font-display text-lg font-semibold uppercase leading-tight text-terra-deep sm:text-xl" data-id="element-90" data-mp="oxf9y8phgns1">
              {guarantee.claim}
            </p>
          </div>
        </div>
      </div>
    </section>;
}